var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"xcard"},[_c('p',[_vm._v("Graficos")]),_c('canvas',{attrs:{"id":"myChart","width":"400","height":"400"}})])
}]

export { render, staticRenderFns }